import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

import Link from 'next/link';
import Modal from '../../ui/Modal';
import ModalSelectRegion from '../ModalSelectRegion';
import { getLSRegion } from '@/store/ls/region';
import { getRegions } from '@/helpers/api';
import useDeviceDetect from '../../helpers/hooks';
import Image from 'next/image';

const AddressIcon = '/img/icons/location.png';

export const mainRegion = {
  id: 0,
  name: 'Республика Татарстан'
}

const defaultRegions = [
  mainRegion,
  {
    id: 4,
    name: 'г. Казань'
  },{
    id: 136,
    name: 'г. Набережные Челны'
  }
]

export const DEFAULT_REGION_ID = 4;

export default function Info(){
  
  const [openMenu, setOpenMenu] = useState(false);
  const { isMobile } = useDeviceDetect();
  const [openOpenSelectRegion, setOpenSelectRegion] = useState(false);
  const [region, setRegion] = useState(defaultRegions.find(item => item.id === DEFAULT_REGION_ID));
  const [regions, setRegions] = useState(defaultRegions);
  
  useEffect(() => {

    async function loadRegions () {
      const regions = await getRegions();
      setRegions([mainRegion, ...regions]);

      const lsReg = getLSRegion();
      if (lsReg) {
        setOpenSelectRegion(false);
        setRegion(lsReg);
      }
    }
    
    loadRegions();
    
  }, []);

  return <Container>
    <div className="maxwidth">
      <Contacts>

        <a onClick={() => setOpenSelectRegion(true)}>
          <Image src={AddressIcon} alt="" width={15} height={23}/>
          {region.name}
        </a>

      </Contacts>

      {isMobile && <MobMenuIcon onClick={() => setOpenMenu(true)}>
        <span></span>
        <span></span>
        <span></span>
      </MobMenuIcon>}
      {!isMobile && <Menu>
        <Link href="/">Главная</Link>
        <Link href="/pharmacies/type/proizv">Аптечное производство</Link>
        <Link href="/pharmacies/type/all">Наши аптеки</Link>
        <Link href="/catalog/а/1">Алфавитный указатель</Link>
        <Link href="/articles/0">Статьи</Link>
        <Link href="/text/about">О нас</Link>
        <Link href="/feedback">Оставить отзыв</Link>
        <a href="/documents/ttmf-instructions.pdf" target="_blank">Инструкция</a>
      </Menu>}
    </div>

      {isMobile && openMenu && <MobMenu onClick={() => setOpenMenu(false)}>
        <CloseMenu>
          Закрыть
        </CloseMenu>
        <p>
          <Title>Меню</Title>
        </p>
        
        <p>
          <Link href="/">Главная</Link>
          <Link href="/pharmacies/type/proizv">Аптечное производство</Link>
          <Link href="/pharmacies/type/all">Наши аптеки</Link>
          <Link href="/catalog/а/1">Алфавитный указатель</Link>
          <Link href="/articles/0">Статьи</Link>
          <Link href="/text/about">О нас</Link>
          <Link href="/feedback">Оставить отзыв</Link>
          <a href="/documents/ttmf-instructions.pdf" target="_blank">Инструкция</a>
        </p>
      </MobMenu>}

      {openOpenSelectRegion && <Modal position="center">
        <ModalSelectRegion onClose={() => setOpenSelectRegion(false)} regions={regions} region={region} setRegion={setRegion} />
      </Modal>}
  </Container>
}

const CloseMenu = styled.a`
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 10px;
`

const Title = styled.h2`
  font-size: var(--text-title);
  text-transform: uppercase;
  font-family: var(--font-semibold);
  color: var(--color-title);
  margin: 0 0 10px;

  & span {
    color: var(--green);
  }
`

const MobMenu = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-bg);
  z-index: 1000;
  color: var(--color-title);
  white-space: initial;
  flex-direction: column;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  padding: 40px 20px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 24px;

  & p {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    padding: 0 20px;
  }

  & p::after {
    content: '';
    background-color: var(--color-bg-lightgray);
    position: absolute;
    bottom: -14px;
    left: 0;
    width: 100%;
    height: 1px;
  }

  & p:last-child {
    font-family: var(--font-medium);
  }

`

const MobMenuIcon = styled.a`
  width: 20px;
  display: grid;
  grid-template-rows: 2px 2px 2px;
  grid-row-gap: 5px;

  & span {
    background-color: var(--green);
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--color-bg-invert);
  color: var(--color-text-invert);
  height: 45px;

  & > div {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  @media (max-width: 480px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
`
const Contacts = styled.div`
  font-size: 15px;

  & > a:first-child {
    font-size: 16px;
    font-family: var(--font-medium);
  }
  & > a {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
  }

  & img {
    margin-right: 10px;
  }

  /* @media (max-width: 480px) {
    font-size: 0px;
    & > a:first-child {
      font-size: 0px;
    }
  } */
`

const Menu = styled.nav`
  text-transform: uppercase;
  color: var(--color-menu);
  font-size: var(--text-uppercase-menu);
  color: #fff;

  & a {
    margin-left: 20px;
  }

  @media (max-width: 1120px) {
    display: none;
  }
`